import React from 'react';
import styles from './MapSlim.module.sass';
import bg from './assets/bg.webp';
import marker from './assets/marker.svg';

import cloud from './assets/cloud-1.webp';
import cloud2 from './assets/cloud-2.webp';

export function MapSlim() {
  return (
    <section className={styles.mapSlim}>
      <img src={bg} alt="" className={styles.mapSlim__bg} aria-hidden />
      <div className={styles.mapSlim__gradient} aria-hidden />

      <img src={marker} alt="" className={styles.mapSlim__marker1} aria-hidden />
      <img src={marker} alt="" className={styles.mapSlim__marker2} aria-hidden />

      <div className={styles.mapSlim__offices}>
        <div className={styles.mapSlim__office}>
          <span className={styles.mapSlim__officeLabel}>центральный офис</span>
          <span className={styles.mapSlim__officeAddress}>ул. Екатерининская, 165</span>
        </div>
        <div className={styles.mapSlim__office}>
          <span className={styles.mapSlim__officeLabel}>мобильный офис</span>
          <span className={styles.mapSlim__officeAddress}>ул. Рионская, 4а</span>
        </div>
      </div>
      <img  src={cloud} alt="Облако" className={styles['mapSlim__cloud-1']} />
      <img  src={cloud2} alt="Облако" className={styles['mapSlim__cloud-2']} />
    </section>
  );
}
